<template>
    <modal :width-auto="true" :min_width="340" :max_width="800" :max_height="600" class="modal-news" :disablePortal="true">
     <div class="px-6 py-10 w-full relative">
         <img @click="close" class="hover:text-grey-darkest cursor-pointer h-4 absolute pin-t pin-r m-4" src="@/assets/SVG/cross-partners.svg"/>
         <div class="flex flex-col">
           <div class="flex justify-center text-md font-bold mb-2 text-brand-light">Статистика по играм</div>

           <div class="font-normal text-center text-xs md:text-sm leading-5">
             <p>Напоминаем, что в разделе «Текущая регистрация» <br>есть  мероприятия без статистики.</p>
             <p>Не забудьте отправить данные перед <br> заказом новой игры.</p>
           </div>
         </div>
     </div>
    </modal>
</template>
<script >
import ModalMixin from '../../../../../mixins/modals';
import Modal from '@/views/modals/base-modal';
import * as Cookies from 'js-cookie';

export default {
  name: 'stat-notification-modal',
  components: { Modal },
  props: ['cityId'],
  mixins: [ModalMixin],
  mounted() {
    setTimeout(() => {
      const cities = Cookies.getJSON('statNotification') || [];
      cities.push(this.cityId);
      Cookies.set('statNotification', cities, { expires: 1 });
    }, 2500);
  },
};
</script>
